import React from "react";

interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
}

export function Container({
  children,
  className,
}: ContainerProps): JSX.Element {
  return (
    <div className={`w-full flex justify-center ${className}`}>
      <div className="flex max-w-[1440px] w-full px-m mobile:px-[45px]">{children}</div>
    </div>
  );
}
